var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"print-warning print-only print-centered"},[_c('div',[_vm._v("Thank you for your interest in ReadWorks.")]),_vm._v(" "),_c('div',[_vm._v("Please sign in or create your free Educator account in order to print.")])])
}]

export { render, staticRenderFns }